// material-ui
import { Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react';
// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { getProducts, filterProducts } from 'store/shopActions';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const productState = useSelector((state) => {
        return state.shop;
    });
    useEffect(() => {
        dispatch(getProducts());
    }, []);
    useEffect(() => {
        setProducts(productState.products);
    }, [productState]);

    const navItems = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} products={products} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    return <>{navItems}</>;
};

export default MenuList;
